import { useSyncExternalStore } from "react";
import { getFeatureSnapshot, subscribeToFeatures } from "../utils/features";

/**
 * Returns the same shape BetaLabel used to read from `FeatureStore.getFeatureState()`: `{ activeFeatures, isBeta, betaMessage }`.
 * @returns {{ activeFeatures: string[], isBeta: boolean, betaMessage: (import("react").ReactNode|null) }}
 */
const useFeatures = () => useSyncExternalStore(subscribeToFeatures, getFeatureSnapshot);

export default useFeatures;
